import { QLE_ACTION_TYPES } from '@constants/actionTypes/qleVerificationActionTypes';

interface qleAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    verificationsData: {},
};

export default(state = INITIAL_STATE, action: qleAction) => {
    switch (action?.type) {
        case QLE_ACTION_TYPES.SET_QLE_VERIFICATIONS_DATA: {
            return {
                ...state,
                verificationsData: action.payload,
            };
        };
        case QLE_ACTION_TYPES.OVERRIDE_DOCUMENT: {
            return {
                ...state,
                verificationsData: action.payload,
            };
        };
        default:
            return state;
    }
};
